const c = {
  "cdr-icon": "cdr-icon_15-5-1",
  "cdr-icon--small": "cdr-icon--small_15-5-1",
  "cdr-icon--large": "cdr-icon--large_15-5-1",
  "cdr-icon--small@xs": "cdr-icon--small@xs_15-5-1",
  "cdr-icon--large@xs": "cdr-icon--large@xs_15-5-1",
  "cdr-icon--small@sm": "cdr-icon--small@sm_15-5-1",
  "cdr-icon--large@sm": "cdr-icon--large@sm_15-5-1",
  "cdr-icon--small@md": "cdr-icon--small@md_15-5-1",
  "cdr-icon--large@md": "cdr-icon--large@md_15-5-1",
  "cdr-icon--small@lg": "cdr-icon--small@lg_15-5-1",
  "cdr-icon--large@lg": "cdr-icon--large@lg_15-5-1",
  "cdr-icon--inherit-color": "cdr-icon--inherit-color_15-5-1"
};
export {
  c as default
};
